import React, { Fragment, lazy } from 'react';
import { Route } from 'react-router-dom';
import { ProtectedRoute } from '../components/ProtectedRoute';
const OnboardingFlow = lazy(() => import('../pages/OnboardingFlow').then(m => ({
  default: m.OnboardingFlow
})));
const DashboardPage = lazy(() => import('../pages/DashboardPage').then(m => ({
  default: m.DashboardPage
})));
const UploadPage = lazy(() => import('../pages/UploadPage').then(m => ({
  default: m.UploadPage
})));
const AnalysisPage = lazy(() => import('../pages/AnalysisPage').then(m => ({
  default: m.AnalysisPage
})));
const ProfilePage = lazy(() => import('../pages/ProfilePage').then(m => ({
  default: m.ProfilePage
})));
const AllScansPage = lazy(() => import('../pages/AllScansPage').then(m => ({
  default: m.AllScansPage
})));
const SettingsPage = lazy(() => import('../pages/SettingsPage').then(m => ({
  default: m.SettingsPage
})));
const MonthlyReportPage = lazy(() => import('../pages/MonthlyReportPage').then(m => ({
  default: m.MonthlyReportPage
})));
const PremiumToolsPage = lazy(() => import('../pages/PremiumToolsPage').then(m => ({
  default: m.PremiumToolsPage
})));
const MessageRewriterPage = lazy(() => import('../pages/MessageRewriterPage').then(m => ({
  default: m.MessageRewriterPage
})));
const PaymentPage = lazy(() => import('../pages/PaymentPage').then(m => ({
  default: m.PaymentPage
})));
export const protectedRoutes = <Fragment data-id="element-10950">
    <Route path="/onboarding" element={<ProtectedRoute data-id="element-10952">
          <OnboardingFlow data-id="element-10953" />
        </ProtectedRoute>} data-id="element-10951" />
    <Route path="/dashboard" element={<ProtectedRoute data-id="element-10955">
          <DashboardPage data-id="element-10956" />
        </ProtectedRoute>} data-id="element-10954" />
    <Route path="/upload" element={<ProtectedRoute data-id="element-10958">
          <UploadPage data-id="element-10959" />
        </ProtectedRoute>} data-id="element-10957" />
    <Route path="/analysis" element={<ProtectedRoute data-id="element-10961">
          <AnalysisPage data-id="element-10962" />
        </ProtectedRoute>} data-id="element-10960" />
    <Route path="/tools" element={<ProtectedRoute data-id="element-10964">
          <PremiumToolsPage data-id="element-10965" />
        </ProtectedRoute>} data-id="element-10963" />
    <Route path="/tools/rewriter" element={<ProtectedRoute data-id="element-10967">
          <MessageRewriterPage data-id="element-10968" />
        </ProtectedRoute>} data-id="element-10966" />
    <Route path="/premium-tools" element={<ProtectedRoute data-id="element-10970">
          <PremiumToolsPage data-id="element-10971" />
        </ProtectedRoute>} data-id="element-10969" />
    <Route path="/profile" element={<ProtectedRoute data-id="element-10973">
          <ProfilePage data-id="element-10974" />
        </ProtectedRoute>} data-id="element-10972" />
    <Route path="/all-scans" element={<ProtectedRoute data-id="element-10976">
          <AllScansPage data-id="element-10977" />
        </ProtectedRoute>} data-id="element-10975" />
    <Route path="/monthly-report" element={<ProtectedRoute data-id="element-10979">
          <MonthlyReportPage data-id="element-10980" />
        </ProtectedRoute>} data-id="element-10978" />
    <Route path="/settings" element={<ProtectedRoute data-id="element-10982">
          <SettingsPage data-id="element-10983" />
        </ProtectedRoute>} data-id="element-10981" />
    <Route path="/payment" element={<ProtectedRoute data-id="element-10985">
          <PaymentPage data-id="element-10986" />
        </ProtectedRoute>} data-id="element-10984" />
  </Fragment>;